var _defs, _g, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    height: 24,
    width: 24,
    "data-name": "Ebene 1",
    id: "Ebene_1"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2-7",
    transform: "matrix(.1909 0 0 .19077 -.147 -.112)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    id: "rect818-5",
    fill: "#f5f6f8",
    stroke: "#212529",
    strokeWidth: 0,
    strokeMiterlimit: 10,
    d: "M.5.39h126v126H.5z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle6",
    r: 5.815,
    cy: 7.76,
    cx: 12,
    className: "cls-1",
    fill: "none",
    stroke: "#212529",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M.706 22.576c0-7.702 5.056-8.69 11.294-8.69s11.294.987 11.294 8.69",
    className: "cls-1",
    fill: "none",
    stroke: "#212529",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeDasharray: "none"
  })));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICB2ZXJzaW9uPSIxLjEiCiAgIHZpZXdCb3g9IjAgMCAyNCAyNCIKICAgaGVpZ2h0PSIyNCIKICAgd2lkdGg9IjI0IgogICBkYXRhLW5hbWU9IkViZW5lIDEiCiAgIGlkPSJFYmVuZV8xIj4KICA8ZGVmcwogICAgIGlkPSJkZWZzNCI+CiAgICA8c3R5bGUKICAgICAgIGlkPSJzdHlsZTIiPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgICAgc3Ryb2tlOiAjMjEyNTI5OwogICAgICAgIHN0cm9rZS1taXRlcmxpbWl0OiAxMDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcKICAgICBpZD0ibGF5ZXIyLTciCiAgICAgdHJhbnNmb3JtPSJtYXRyaXgoMC4xOTA4OTc1MiwwLDAsMC4xOTA3NzM1MSwtMC4xNDY4NDAwNywtMC4xMTE5OTg1NykiPgogICAgPHJlY3QKICAgICAgIHN0eWxlPSJmaWxsOiNmNWY2Zjg7c3Ryb2tlOiMyMTI1Mjk7c3Ryb2tlLXdpZHRoOjBweDtzdHJva2UtbWl0ZXJsaW1pdDoxMCIKICAgICAgIGhlaWdodD0iMTI2IgogICAgICAgd2lkdGg9IjEyNiIKICAgICAgIHk9IjAuMzg5OTk5OTkiCiAgICAgICB4PSIwLjUiCiAgICAgICBjbGFzcz0iY2xzLTEiCiAgICAgICBpZD0icmVjdDgxOC01IiAvPgogIDwvZz4KICA8Y2lyY2xlCiAgICAgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzIxMjUyOTtzdHJva2Utd2lkdGg6MC40MDAwMDAwMTtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2UtZGFzaGFycmF5Om5vbmUiCiAgICAgaWQ9ImNpcmNsZTYiCiAgICAgcj0iNS44MTUwMDAxIgogICAgIGN5PSI3Ljc1OTk5OTgiCiAgICAgY3g9IjEyIgogICAgIGNsYXNzPSJjbHMtMSIgLz4KICA8cGF0aAogICAgIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiMyMTI1Mjk7c3Ryb2tlLXdpZHRoOjAuNDAwMDAwMDE7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLWRhc2hhcnJheTpub25lIgogICAgIGlkPSJwYXRoOCIKICAgICBkPSJtIDAuNzA2LDIyLjU3NiBjIDAsLTcuNzAyIDUuMDU2LC04LjY5IDExLjI5NCwtOC42OSA2LjIzOCwwIDExLjI5NCwwLjk4NyAxMS4yOTQsOC42OSIKICAgICBjbGFzcz0iY2xzLTEiIC8+Cjwvc3ZnPgo=";
export { SvgComponent as ReactComponent };